import React from 'react';
import { withStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const styles = () => {
  return {
    page: {
      fontSize: 15,
    },
    noDecoration: {
      textDecoration: 'none',
      color: 'black',
    },
    indentRight: {
      marginTop: 3,
      marginBottom: 7,
      marginLeft: '1em',
    },
  };
};

class ChildList extends React.Component {
  render() {
    const { classes, term, definitions, videos, level, expanded } = this.props;
    const children = definitions[term] ? definitions[term]['Children'] : {};
    return (
      <div className={classes.page}>
        {!expanded ? (
          <Typography>
            <Link className={classes.noDecoration} to={'/term/' + term}>
              <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                ⊕{' '}
              </div>
              <div
                style={{
                  display: 'inline-block',
                  marginBottom: 2,
                  marginLeft: 3,
                  maxWidth: 100,
                }}
              >
                {term}
                {videos[term] ? '' : '*'}
              </div>
            </Link>
          </Typography>
        ) : (
          <div>
            <Typography>
              <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
                ⊖{' '}
              </div>
              <div
                style={{
                  display: 'inline-block',
                  marginBottom: 2,
                  marginLeft: 3,
                  maxWidth: 100,
                }}
              >
                <b>{term}</b>
                {videos[term] ? '' : '*'}
              </div>
            </Typography>
            <div className={classes.indentRight}>
              {level === 'USER' ? (
                <Link
                  onClick={this.props.requestTerm}
                  style={{ marginTop: 5, marginBottom: 10 }}
                >
                  <i>
                    <Typography>Request New Term</Typography>
                  </i>
                </Link>
              ) : level === 'MAINTAINER' || level === 'ADMIN' ? (
                <Link
                  to={'/add-term/' + term}
                  style={{ marginTop: 5, marginBottom: 10 }}
                >
                  <i>
                    <Typography>Add Child Term</Typography>
                  </i>
                </Link>
              ) : (
                <div />
              )}
              {children !== undefined ? (
                Object.keys(children).map((key) => (
                  <Typography>
                    <Link
                      className={classes.noDecoration}
                      to={'/term/' + children[key]}
                    >
                      <div>
                        <div
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'top',
                          }}
                        >
                          ⊕{' '}
                        </div>
                        <div
                          style={{
                            display: 'inline-block',
                            marginLeft: 3,
                            marginBottom: 2,
                            maxWidth: 100,
                          }}
                        >
                          {children[key]}
                          {videos[key] ? '' : '*'}
                        </div>
                      </div>
                    </Link>
                  </Typography>
                ))
              ) : (
                <div />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ChildList);
